import React from 'react';

import { Box, Flex, Text } from '@chakra-ui/react';
import { Form, Formik } from 'formik';
import keys from 'lodash/keys';
import pickBy from 'lodash/pickBy';
import {
  useNotificationSettings,
  useUpdateNotificationSettings,
} from 'queries/notificationSettings';

import FormikCheckbox from 'components/common/Form/FormikCheckbox';

import { useToastContext } from '../common/ToastBannerProvider/ToastBannerProvider';

export default function NotificationSettingsForm() {
  const { addToast } = useToastContext();
  const { data: settings } = useNotificationSettings();
  const onSuccess = () => {
    addToast({
      message: 'Notification settings has been updated.',
      variant: 'success',
    });
  };
  const onError = (error) => {
    addToast({
      message: 'Something went wrong updating notification settings.',
      variant: 'alert',
    });
  };
  const { mutate: mutateUpdateNotificationSettings } =
    useUpdateNotificationSettings({
      onError,
      onSuccess,
    });

  const handleSubmit = async ({ settings }) => {
    mutateUpdateNotificationSettings({
      settings: keys(pickBy(settings)),
    });
  };

  const settingsList = ['weekly_summary'];

  const initialValues = {
    settings: settingsList.reduce((list, setting) => {
      list[setting] = settings.includes(setting);

      return list;
    }, {}),
  };

  return (
    <Box pt={4}>
      <Text as="h3" color="grey.900" size={4}>
        Organization Settings
      </Text>
      <Flex>
        <Flex width="1100px">
          <Box maxWidth="656px" width="100%">
            <Formik
              enableReinitialize
              onSubmit={handleSubmit}
              initialValues={initialValues}
            >
              {({ handleChange, submitForm, values }) => {
                return (
                  <Form>
                    <FormikCheckbox
                      data-testid="weekly_summary"
                      isChecked={values.settings.weekly_summary}
                      name="settings.weekly_summary"
                      mb="2"
                      onChange={(event) => {
                        handleChange(event);
                        submitForm();
                      }}
                    >
                      <Text mb="0">Weekly summary</Text>
                      <Text fontSize="sm" color="grey.700" mb="0">
                        Receive a weekly digest of incidents and retrospectives
                        for your organization.
                      </Text>
                    </FormikCheckbox>
                  </Form>
                );
              }}
            </Formik>
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
}
